import { EnumFinanceStatChannel, EnumFinanceStatChannelOption } from "./EnumFinanceStatChannel";
import { EnumFinanceStatType, EnumFinanceStatTypeOption } from "./EnumFinanceStatType";
import { EnumCompositionType, EnumCompositionTypeOption } from "./EnumCompositionType";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestCount {
    constructor() {
        //无参构造函数
        this.Channel = EnumFinanceStatChannel.Overview;
        this.Type = EnumFinanceStatType.Collection;
        this.IsFinancialCycle = false;
    }

    [proName: string]: any;
    /**
     * 栏目
     */
    Channel?: EnumFinanceStatChannel;
    /**
     * 类型
     */
    Type?: EnumFinanceStatType;
    /**
     * 月份
     */
    Month?: string;
    /**
     * 服务商下的企业
     */
    CompanyId?: string;
    /**
     * 币制
     */
    CurrencySystemId?: string;
    /**
     * 业务员主键
     */
    SalerId?: string;
    /**
     * 组成类型
     */
    CompositionType?: EnumCompositionType;
    /**
     * 财务周期
     */
    IsFinancialCycle?: boolean;
}

/**
 * -表单校验
 */
export const DtoRequestCountRules = {
}
